/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface B2BPaymentType
 */
export interface B2BPaymentType {
    /**
     * 
     * @type {string}
     * @memberof B2BPaymentType
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof B2BPaymentType
     */
    displayName?: string;
}

/**
 * Check if a given object implements the B2BPaymentType interface.
 */
export function instanceOfB2BPaymentType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function B2BPaymentTypeFromJSON(json: any): B2BPaymentType {
    return B2BPaymentTypeFromJSONTyped(json, false);
}

export function B2BPaymentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2BPaymentType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
    };
}

export function B2BPaymentTypeToJSON(value?: B2BPaymentType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'displayName': value.displayName,
    };
}

